function compareNames(a, b){
    if(a.name && b.name){
	return a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1;
    }

    return a.name > b.name ? 1 : -1;
}

export const sortOptions = (options) => {
    const isArray = Array.isArray(options);
    if (isArray) {
	return options.sort(compareNames);
    }
    return "";
};
